import React from "react";
import RuleSettingsProvider from './contexts/rule-settings-context';
import RulesSettingsContainer from './components/rules-settings-container';
import PropTypes from 'prop-types';

const PhysicianSupervisionRules = ({ handleRuleUpdate, ...props }) => {
  return (
    <RuleSettingsProvider {...props} handleRuleUpdate={handleRuleUpdate} >
      <RulesSettingsContainer />
    </RuleSettingsProvider>
  );
};

PhysicianSupervisionRules.prototype = {
  handleRuleUpdate: PropTypes.func,
  chartSizeScales: PropTypes.arrayOf(PropTypes.string),
  chartSize: PropTypes.number,
  chartType: PropTypes.string,
  mustContainRx: PropTypes.bool
};

export default PhysicianSupervisionRules;
